export default "<p *ngIf=\"this.error\">{{this.error}}</p>\r\n";